<!-- <ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>addsoundtext</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">addsoundtext</ion-title>
    </ion-toolbar>
  </ion-header>
</ion-content>
 -->


 <ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>Add Texts/Sounds</ion-title>
    <ion-buttons slot="end">
      <ion-title style="cursor: pointer;" size="large" (click)="goToMenu()">Menu</ion-title>
      <!-- <ion-title style="cursor: pointer;" size="large" (click)="goToAdminPage()">Admin</ion-title> -->
      <ion-title style="cursor: pointer;" size="large" (click)="confirmLogout()">Logout</ion-title>
  </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
   
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">demo</ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content [fullscreen]="true">
    <ion-header collapse="condense">
      <ion-toolbar>
        <ion-title size="large">demo</ion-title>
      </ion-toolbar>
    </ion-header>
  
    <ion-content class="no-hover-page" [fullscreen]="true">
      
      <ng-container >
        <form [formGroup]="addSoundTextForm" (ngSubmit)="onSubmit()" class="addtext-form">
          <ion-list>
            <div formArrayName="soundTextArray">
              <div *ngFor="let formEntry of soundTextArray.controls; let i = index" [formGroupName]="i">
                <ion-card>
                  <!-- Remove button positioned at the top-right corner -->
                    <div class="remove-button-container">

                    
                      <ion-button
                        fill="clear"
                        color="danger"
                        (click)="removeFormEntry(i)"
                        class="remove-button"
                      >
                        <ion-icon name="close-outline"></ion-icon>
                      </ion-button>
                    </div>
                  <!-- <ion-card-header>
                    <ion-card-title>Entry {{ i + 1 }}</ion-card-title>
                  </ion-card-header> -->
    
                  <ion-card-content>
                    <ion-item class="form-item">
                      <ion-input 
                        formControlName="message"
                        type="text"
                        required
                        placeholder="Enter your text here ..."
                      ></ion-input>
                    </ion-item>
    
                    <ion-row>
                      <ion-col>
                        <ion-item class="form-item">
                          <ion-label position="floating">Language:</ion-label>
                          <ion-select formControlName="lang" required>
                          <!-- <ion-select formControlName="lang" required interface="popover"> -->
                            <ion-select-option value="nl">Dutch</ion-select-option>
                            <ion-select-option value="english">English</ion-select-option>
                          </ion-select>
                        </ion-item>
                      </ion-col>
                      <ion-col>
                        <ion-item class="form-item">
                          <ion-label position="floating">Type:</ion-label>
                          <ion-select formControlName="type" required>
                          <!-- <ion-select formControlName="type" required interface="popover"> -->
                            <ion-select-option value="prioritize_text">PrioritizeText</ion-select-option>
                            <ion-select-option value="mozilla_text">MozillaText</ion-select-option>
                            <ion-select-option value="text">Text</ion-select-option>
                            <ion-select-option value="surveyforms">SurveyForms</ion-select-option>
                            <ion-select-option value="character">Character</ion-select-option>
                            <ion-select-option value="number">Number</ion-select-option>
                            <ion-select-option value="outbound">Outbound</ion-select-option>
                          </ion-select>
                        </ion-item>
                      </ion-col>
                    </ion-row>
    
                    <ion-row>
                      <!-- <ion-col>
                        <ion-item>
                          <ion-button>Record</ion-button>
                        </ion-item>
                      </ion-col> -->
                      <ion-col>
                        <ion-item class="custom-item">
                          <!-- <ion-button [ngClass]="{'pulse': isRecording,'red-button': isRecording,}" style="width:120px" *ngIf="!isFileSelected" (click)="startRecording()">{{ isRecording ? 'Recording' : 'Record' }}</ion-button> -->

                          <ion-button style="width:120px" *ngIf="!isFileSelected[i] && !recordingStates[i] && !stoppingStates[i] && !filesSelected[i]" (click)="startRecording(i)">
                            <!-- {{ isRecording ? 'Recording' : 'Record' }} -->
                            Record
      
                            <ion-icon *ngIf="recordingStates[i]" name="stop-circle-outline"></ion-icon>
                            <!-- <ion-icon *ngIf="!isRecording" name="mic-outline"></ion-icon> -->
                          </ion-button>
                          
                          <ion-button [ngClass]="{'pulse': recordingStates[i], 'red-button': recordingStates[i]}" *ngIf="recordingStates[i]" (click)="stopRecording(i)">Recording</ion-button>
                          <ion-button style="width:120px" *ngIf="recordingStates[i]" (click)="stopRecording(i)">Stop</ion-button>
                          <ion-button style="width:120px" *ngIf="stoppingStates[i] && !recordingStates[i] && !filesSelected[i] && !playingStates[i]" (click)="playRecording(i)">Play</ion-button>
                          <ion-button style="width:120px" [ngClass]="{'pulse': playingStates[i], 'red-button': playingStates[i]}" *ngIf="playingStates[i]">Playing</ion-button>

                          <ion-button style="width:120px" *ngIf="stoppingStates[i] && !recordingStates[i] && !filesSelected[i]" [disabled] = "!playingStates[i]" (click)="stopPlaying(i)">Stop</ion-button>
                          <span class="separator" [hidden]="isFileSelected[i] || recordingStates[i]"></span>
                          <span class="separator" [hidden] = "isFileSelected[i] || recordingStates[i] || stoppingStates[i] || filesSelected[i]">or</span>
                          <input 
                            *ngIf="!recordingStates[i] && !stoppingStates[i]"
                            type="file" 
                            #fileInput
                            accept="audio/*" 
                            id="fileInput"
                            (change)="onFileSelected($event, i)" />
                            <!-- <div class="file-input-wrapper">
                              <label for="fileInput" class="custom-file-upload">Select File</label>
                              <input type="file" id="fileInput" style="display: none;" />
                            </div> -->
                        </ion-item>
                      </ion-col>
                      <ion-col>
                        <ion-item lines="none">
                          <!-- <ion-button>Clear</ion-button> -->
                          <ion-icon name="trash-outline" (click)="clearFileInput(i)" [hidden] = "isFileSelected[i] || !recordingStates[i] || stoppingStates[i]"></ion-icon>
                        </ion-item>
                      </ion-col>
                    </ion-row>
    
                    <ion-row>
                        <ion-item>
                          <ion-checkbox 
                            (ionChange)="onToggleChange($event, i, 'isForInterpretation')" 
                            formControlName="isForInterpretation"
                          >UsedForInterpretationOnly:</ion-checkbox>
                        </ion-item>
                    </ion-row>
                  </ion-card-content>
                </ion-card>
              </div>
            </div>
            <ion-row>

              <!-- <ion-item>
                  <ion-icon slot="start" name="add-outline" (click)="addFormEntry()"></ion-icon>
              </ion-item> -->

            </ion-row>
                <ion-row>  
                  <ion-col size="10"></ion-col>
                  <ion-col size="2">  
                    <ion-item lines="none">  
                        <ion-icon slot="end" name="add-outline" (click)="addFormEntry()"></ion-icon>
                    </ion-item>
                  </ion-col>
            </ion-row>

            

          
            <ion-button type="submit" expand="block" class="submit-button" [disabled]="!addSoundTextForm.valid">Save</ion-button>
          </ion-list>
        </form>
      </ng-container>
    </ion-content>
    
  </ion-content>
  

  

  <!-- <form [formGroup]="addSoundTextForm" (ngSubmit)="onSubmit()" class="addtext-form">
    <ion-list formArrayName="soundTextArray">
      <div *ngFor="let formEntry of soundTextArray.controls; let i = index" [formGroupName]="i">
        
        <ion-item class="form-item">
          <ion-input formControlName="message" type="text" required placeholder="Enter your text here ...">
          </ion-input>
        </ion-item>  
  
        <ion-row>
          <ion-col>
            <ion-item class="form-item">
              <ion-label position="floating">Language:</ion-label>
              <ion-select formControlName="lang" required interface="popover">
                <ion-select-option value="nl">Dutch</ion-select-option>
                <ion-select-option value="english">English</ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
          <ion-col>
            <ion-item class="form-item">
              <ion-label position="floating">Type:</ion-label>
              <ion-select formControlName="type" required interface="popover">
                <ion-select-option value="text">Text</ion-select-option>
                <ion-select-option value="surveyforms">SurveyForms</ion-select-option>
                <ion-select-option value="character">Character</ion-select-option>
                <ion-select-option value="number">Number</ion-select-option>
                <ion-select-option value="outbound">Outbound</ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>
  
        <ion-row>
          <ion-col>
            <ion-item class="form-item">
              <input type="file" accept="audio/*" (change)="onFileSelected($event, i)" />
            </ion-item>
          </ion-col>
          <ion-col>
            <ion-item>
              <ion-label class="toggle-label">UsedForInterpretationOnly</ion-label>
              <ion-toggle (ionChange)="onToggleChange($event, i, 'isForInterpretation')" formControlName="isForInterpretation"></ion-toggle>
            </ion-item>
          </ion-col>
        </ion-row>
  
        <ion-row>
          <ion-col>
            <ion-label class="toggle-label">Add Text Only</ion-label>
            <ion-checkbox (ionChange)="onToggleChange($event, i, 'addTextOnly')" formControlName="addTextOnly"></ion-checkbox>
          </ion-col>
        </ion-row>
  
        <ion-button (click)="removeFormEntry(i)" color="danger">Remove</ion-button>
      </div>
    </ion-list>
  
    <ion-button (click)="addFormEntry()">Add Entry</ion-button>
    <ion-button type="submit" expand="block" class="submit-button" [disabled]="!addSoundTextForm.valid">Save</ion-button>
  </form>
   -->
  
</ion-content>
